import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { Component, forwardRef, Input } from "@angular/core";

import { STRING } from "../../../constants/string";
import { FieldCoreComponent } from "../FieldCoreComponent";

@Component({
  selector: "med-input",
  templateUrl: "./med-input.component.html",
  styleUrls: ["./med-input.component.scss"],
  providers: [{
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MedInputComponent),
  }],
})
export class MedInputComponent extends FieldCoreComponent<string | number> {
  @Input() role = "textbox";
  @Input() type = "text"; // https://developer.mozilla.org/ru/docs/Web/HTML/Element/Input#attr-type
  @Input() min: string | number = STRING.EMPTY;
  @Input() max: string | number = STRING.EMPTY;
  @Input() formatNumber = false;
  @Input() precision?: number;
}
